import { render, staticRenderFns } from "./modalEditKonfirmasi.vue?vue&type=template&id=37cca24b"
import script from "./modalEditKonfirmasi.vue?vue&type=script&lang=js"
export * from "./modalEditKonfirmasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports